let TabState = require('@/mixins/TabState');

module.exports = {

    mixins:[TabState],

    props: {
        data: {}
    },

    data() {
        return {
            user: this.data.user,
        }
    },

    mounted(){
        this.usePushStateForTabs('#employer-application-tabs');
    },

    computed: {

        canAccessPersonalInformation() {
            if (this.user == null) return false;
            return true;
        },

        canAccessCompanies() {
            if (this.user == null) return false;
            if (!this.user.address || !this.user.city || !this.user.state || !this.user.zip || !this.user.personal_email || !this.user.phone) return false;
            return true;
        },

        canAccessDocuments() {
            if (this.user == null) return false;
            if (this.user.employer == null) return false;
            return true;
        },

        canAccessPayment() {
            return true;
            if (this.user == null) return false;
            if (this.user.employer == null) return false;
            return this.user.employer.is_qualified;
        },
    }
}
